import React from 'react';
import { Chips, ChipWrapper, Spacer, StyledChip } from './ui/Components';
import FullBleedHorizontalScroll from './FullBleedHorizontalScroll';
export const Categories = ({ categories, currentCategory, onClick, }) => {
    return (React.createElement(FullBleedHorizontalScroll, null,
        React.createElement("div", { style: { padding: 6 } },
            React.createElement(Chips, null,
                React.createElement(ChipWrapper, null,
                    categories.map(cat => {
                        return (React.createElement(StyledChip, { className: cat === currentCategory ? 'selected' : '', onClick: () => onClick(cat), key: cat },
                            ' ',
                            cat));
                    }),
                    React.createElement(Spacer, null))))));
};
